/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-12-14 11:02:17
 */
import Vue from "vue";

let BlockStore = Vue.extend({
  data() {
    return {
      states: {
        blockMap: new Map(),
        blocks: [],
      },
    };
  },
});

BlockStore.prototype.mutations = {
  insertBlock(states, { block, pos }) {
    if (!block) return;

    if (!block.label) {
      console.error("Block must have a label.");
      return;
    }
    if (block.label in states.blockMap) return;
    states.blockMap.set(block.label, block);
    if (pos == -1) states.blocks.push(block);
    else states.blocks.splice(pos, 0, block);
    this.$emit("block-added", block);
  },
  updateWidth(states, { index, value }) {
    if (index >= 0 && index < states.blocks.length) {
      states.blocks[index].width = value;
    }
  },
  removeBlock(states, block) {
    if (!block || !block.label || !states.blockMap.get(block.label)) return;
    states.blockMap.delete(block.label);
    states.blocks.$$remove(block);
    this.$emit("block-removed", block);
  },
};

BlockStore.prototype.commit = function (name, ...args) {
  const mutations = this.mutations;
  if (mutations[name]) {
    mutations[name].apply(this, [this.states].concat(args));
  } else {
    throw new Error(`Action[${name}] is missing`);
  }
};

export default BlockStore;
